import { render } from "./beneficiary_id_order_by.vue?vue&type=template&id=b94ca30c&scoped=true"
import script from "./beneficiary_id_order_by.vue?vue&type=script&lang=js"
export * from "./beneficiary_id_order_by.vue?vue&type=script&lang=js"

import "./beneficiary_id_order_by.vue?vue&type=style&index=0&id=b94ca30c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b94ca30c"]])

export default __exports__